<template>
    <BasePageSrpPdf>
        <template v-slot:slot_general_info="slotprop_slot_general_info">
            <ComponentGeneralInfo 
            v-bind:prop_submission="slotprop_slot_general_info.submission"/>
        </template>
        <template v-slot:slot_media="slotprop_slot_media">
            <!-- DISABLE THE ALL MEDIA MODAL TO IMPROVE PDF SIZE AND PERFORMANCE-->
            <ComponentMedia 
            prop_show_modal_for_all="false"
            v-bind:prop_submission="slotprop_slot_media.submission"/>
        </template>
        <template v-slot:slot_services_summaries="slotprop_slot_services_summaries">
            <v-row id="ID-ROW-pdf-page-3">
                <v-col cols="4">
                    <ComponentSummary1 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary2 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary3 
                v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
                <v-col cols="4">
                    <ComponentSummary4 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary5 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
                <v-col cols="4">
                    <ComponentSummary7 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary8 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary13 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
            </v-row>
            <v-row id="ID-ROW-pdf-page-4">
                <v-col cols="4">
                    <ComponentSummary10 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary11 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
                <v-col cols="4">
                    <ComponentSummary12 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary6 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
                <v-col cols="4">
                    <ComponentSummary14 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary9 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
            </v-row>
        </template>
    </BasePageSrpPdf>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS

//MODULE COMPONENTS
import ComponentGeneralInfo from '@/views/module_addon_form_primary_iss_odk/components/ComponentGeneralInfo';
import ComponentMedia from '@/views/module_addon_form_primary_iss_odk/components/ComponentMedia';
import ComponentSummary1 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary1';
import ComponentSummary2 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary2';
import ComponentSummary3 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary3';
import ComponentSummary4 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary4';
import ComponentSummary5 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary5';
import ComponentSummary6 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary6';
import ComponentSummary7 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary7';
import ComponentSummary8 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary8';
import ComponentSummary9 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary9';
import ComponentSummary10 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary10';
import ComponentSummary11 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary11';
import ComponentSummary12 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary12';
import ComponentSummary13 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary13';
import ComponentSummary14 from '@/views/module_addon_form_primary_iss_odk/components/ComponentSummary14';

//BASE_PAGE
import BasePageSrpPdf from '@/views/base_pages/BasePageSrpPdf';

//########################################
//CONST AND VARS
//########################################

//########################################
//MAIN
//########################################

export default {
    name: 'ModulePrimaryIssPageSrpPdf',

    components: {
        //BASE PAGE
        BasePageSrpPdf,

        //GENERIC COMPONENTS

        //MODULE COMPONENTS
        ComponentGeneralInfo,
        ComponentMedia,
        ComponentSummary1,
        ComponentSummary2,
        ComponentSummary3,
        ComponentSummary4,
        ComponentSummary5,
        ComponentSummary6,
        ComponentSummary7,
        ComponentSummary8,
        ComponentSummary9,
        ComponentSummary10,
        ComponentSummary11,
        ComponentSummary12,
        ComponentSummary13,
        ComponentSummary14,
    }
};
</script>
